import { path, pathOr } from "ramda";
import { put, call, select } from "redux-saga/effects";

import { clearStore } from "../actions/StoreAction";
import { history } from "../reducers/configureStore";
import ModalUtil from "../util/modal";
import OrganizationActions from "../reducers/OrganizationReducer";
import ROUTE from "../constants/route";


const getAllAdmins = function* (api) {
	try {
		const token = yield select((state) => state.authen.token);
		const orgID = yield select((state) => state.organization.orgID);
		const res = yield call(api.fetchAdmin, {
			headers: { token, organization: orgID },
		});
		const data = path(["data", "data"], res);
		if (res.ok && data) {
			yield put(OrganizationActions.getAllAdminsSuccess(data));
		} else {
			ModalUtil.showError(res);
			yield put(OrganizationActions.getAllAdminsFailure());
		}
	} catch (e) {
		ModalUtil.showDefaultError();
		yield put(OrganizationActions.getAllAdminsFailure());
	}
};

const fetchOrganizationLogs = function* (api) {
	try {
		const token = yield select((state) => state.authen.token);
		const orgID = yield select((state) => state.organization.orgID);
		const res = yield call(api.fetchOrganizationLogs, {
			headers: { token, organization: orgID },
		});
		const data = path(["data", "data"], res);
		if (res.ok && data) {
			yield put(OrganizationActions.fetchOrganizationLogsSuccess(data));
		} else {
			ModalUtil.showError(res);
			yield put(OrganizationActions.fetchOrganizationLogsFailure());
		}
	} catch (e) {
		ModalUtil.showDefaultError();
		yield put(OrganizationActions.fetchOrganizationLogsFailure());
	}
};

const getOrganizationAppointments = function* (api) {
	try {
		const token = yield select((state) => state.authen.token);
		const orgID = yield select((state) => state.organization.orgID);
		const res = yield call(api.getOrganizationAppointments, {
			headers: { token, organization: orgID },
		});
		const data = path(["data", "data"], res);
		if (res.ok && data) {
			yield put(OrganizationActions.getOrganizationAppointmentsSuccess(data));
		} else {
			ModalUtil.showError(res);
			yield put(OrganizationActions.getOrganizationAppointmentsFailure());
		}
	} catch (e) {
		ModalUtil.showDefaultError();
		yield put(OrganizationActions.getOrganizationAppointmentsFailure());
	}
};

export {
	getAllAdmins,
	fetchOrganizationLogs,
	getOrganizationAppointments,
};



// WEBPACK FOOTER //
// ./src/sagas/OrganizationSaga.js